// *******websocket对象的连接，断开，重连，提供信息处理回调*****************

let _ws;  //唯一的websocket实例
let _url; //连接地址缓存
let connect_flag = false;   //true 断线会尝试重连  false 不尝试

let timer; // 定时器
let count = 5;  // 秒  尝试重连间隔
// let count_total = 300;  //秒
let messageList = [];   //获取信息的回调函数列表
let openList = [];    //连接成功 回调的函数列表


// 循环触发list里的函数
function clientTrigger(list,data){
    if(list.length == 0){
        return false;
    }
    for(let i = 0, fn; fn = list[i++]; ){
        fn.call(this,data)
    }
}

// *************************************************************************************

// 建立一条socket连接
const build = (url,obj) =>{   // url socket地址  obj 传递的参数  callback 接收服务端信息的回调
    // _url = url;
    close();
    _ws = new WebSocket(`ws://${url}`);

    _ws.onopen = ()=>{
        console.log('链接成功 ')
        connect_flag = true;
        clearInterval(timer);
        _ws.send(JSON.stringify(obj));
        clientTrigger(openList);  //触发回调
    }

    _ws.onmessage = (res)=>{
        console.log(res.data);
        clientTrigger(messageList,res.data);
    };

    _ws.onclose = ()=>{  //监听websocket关闭
        console.log('断开连接')
        if(connect_flag){
            timer = setInterval(()=>{
                console.log('重连');
                build(url,{...obj});
            },count*1000);
        }
    }
}

 //关闭连接
const close = ()=>{ 
    connect_flag = false;
    _ws && _ws.close();
}


export default {
    build:build,     //建立连接
    close:close,     //关闭连接
    messageEvent:clientTrigger.bind(this,messageList),    //触发 onMessage 回调

    //添加 收到消息后的回调
    onMessage:(callback)=>{     
        messageList.push(callback);
    },
    //添加 websocket连接成功的回调
    open:(callback)=>{          
        openList.push(callback);
    }          
};


// WEBPACK FOOTER //
// ./src/control/info/socket.js